import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex flex-col justify-center gap-1.5 px-3">
    {[1, 2, 3].map(i => (
      <div key={i} className="flex items-center gap-1">
        <div className="w-2 h-2 bg-primary/30 rounded-sm" />
        <div className="flex-1 h-1.5 bg-zinc-200 dark:bg-zinc-700 rounded" />
      </div>
    ))}
  </div>
);

export default Thumbnail;
